import React from 'react';
import { Stack, Text } from '@fluentui/react';
import { useStyles } from './index.styles';
import clsx from 'clsx';
import { WorkgroupGroups_workgroupGroups_nodes_workgroupGroupItems_nodes } from '../__generated__/WorkgroupGroups';

interface WorkgroupGroupItemProps {
  item: WorkgroupGroups_workgroupGroups_nodes_workgroupGroupItems_nodes;
}

export const WorkgroupGroupItem: React.FC<WorkgroupGroupItemProps> = ({
  item,
}) => {
  const styles = useStyles();
  const { corporateWorkgroup } = { ...item };
  const { name } = { ...corporateWorkgroup };
  return (
    <Stack>
      <Stack verticalAlign="center">
        <Stack
          verticalAlign="center"
          className={clsx({
            [styles.onRenderColumnStack]: true,
            [styles.groupItemHeight]: true,
            [styles.workgroupGroup]: true,
          })}
        >
          <Text className={styles.fontColor} variant="medium">
            {name}
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
};
